@import "../../global/visualization-base.scss";

:host {
  --uui-percent-bar-tooltip-row-gap: var(--uui-small-gap);
  --uui-percent-bar-tooltip-label-right-padding: var(--uui-large-padding);
  --uui-percent-bar-tooltip-numeral-left-padding: var(--uui-small-padding);
}

.uui-percent-bar-tooltip {  
      display: flex;
      align-items: center;
      justify-content: center;
      row-gap: 12px;
      column-gap: 20px;

    &-grid {
      display: grid;
      align-items: center;
      row-gap: var(--uui-percent-bar-tooltip-row-gap);
    }

    &-numeral {
      margin-left: auto;
      padding-left: var(--uui-percent-bar-tooltip-numeral-left-padding);
    }

    &-range {
      padding-right: var(--uui-percent-bar-tooltip-label-right-padding);
    }

    &-column {
      display: flex;
      flex-direction: column;
    }

    &-value {
      margin-left: 10px;
    }
  
    &-legend-dot {
      @include legend-dot;
    }
  }